const state = { 
  shopID: null,
  products: {},
  shops: {}, 
  shopCarts: {},
  subscriptionCart: {},
  shippingAddress: {},
  invoice: null,
  clientSecret: null,
  cartDialog: false,
  cartShowInvoice: false,
  snackbar: {
    show: false,
    text: null,
    timeout: 2000,
  },
  content: {}
};

export default state;
